/**
 * A dedicated file for declaring lazy loaded components
 * https://webpack.js.org/guides/lazy-loading/
 */

/*
/!*****************************
 * Routes Pages
 ****************************!/
export const Beat = () => import(/!* webpackChunkName: "is-beat-page" *!/ './components/routes/beat.vue');
export const SoundKit = () => import(/!* webpackChunkName: "is-soundkit-page" *!/ './components/routes/soundkit.vue');
export const Song = () => import(/!* webpackChunkName: "is-song-page" *!/ './components/routes/song.vue');
export const Contact = () => import(/!* webpackChunkName: "is-contact-page" *!/ './components/routes/contact.vue');
export const Checkout = () => import(/!* webpackChunkName: "is-checkout-page" *!/ './components/routes/checkout.vue');
export const Order = () => import(/!* webpackChunkName: "is-order-page" *!/ './components/routes/order.vue');
export const Search = () => import(/!* webpackChunkName: "is-search-page" *!/ './components/routes/search.vue');
export const Discover = () => import(/!* webpackChunkName: "is-discover-page" *!/ './components/routes/discover.vue');
export const Beats = () => import(/!* webpackChunkName: "is-beats-page" *!/ './components/routes/beats.vue');
export const Songs = () => import(/!* webpackChunkName: "is-songs-page" *!/ './components/routes/songs.vue');
export const Soundkits = () => import(/!* webpackChunkName: "is-soundkits-page" *!/ './components/routes/soundkits.vue');
export const Charts = () => import(/!* webpackChunkName: "is-charts-page" *!/ './components/routes/charts.vue');
export const Licenses = () => import(/!* webpackChunkName: "is-licenses-page" *!/ './components/routes/licenses.vue');
export const About = () => import(/!* webpackChunkName: "is-about-page" *!/ './components/routes/about.vue');
*/


/*****************************
 * Other async components
 ****************************/
export const ConfigurationPanel = () => import(/* webpackChunkName: "is-config-panel" */ "./components/configurationpanels/base.vue");
